<template>
  <div :class="[superpower && superpower.color + '-container']">
    <div class="flex flex-row items-center gap-3 rounded-large p-2 pr-4 cursor-pointer group relative overflow-hidden w-min" @click="router.push({ name: 'superpower' })">
      <div class="relative flex items-center justify-center p-1 h-24 w-24 shrink-0">
        <BaseShapeMask
          shape="12-sided-cookie"
          class="z-20 w-full h-full"
        >
          <img :src="superpower.image" :alt="superpower.title"></img>
        </BaseShapeMask>
        <BaseShape shape="12-sided-cookie" class="absolute z-10 w-full h-full text-primary" />
      </div>
      <div class="flex flex-col">
        <p class="text-on-surface-variant text-body-medium -mb-1">Deine Superkraft</p>
        <h4 class="text-display-small text-primary">{{ superpower.title }}</h4>
      </div>
      <BaseIcon size="24" class="text-on-surface-variant ml-4" :filled="true">open_in_new</BaseIcon>
      <BaseStateLayer type="primary" />
    </div>
  </div>
</template>
<script setup lang="ts">
import BaseIcon from '@/core/components/base/icon/BaseIcon.vue';
import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
import BaseShapeMask from '@/core/components/base/shapes/BaseShapeMask.vue'
import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue';
import type { Skill } from '@/core/models/skill'
import { useRouter } from 'vue-router';

interface Props {
  superpower: Skill
}

defineProps<Props>()

const router = useRouter()
</script>
